import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Delete</DialogTitle>
    <DialogContent>
      <DialogContentText>Do you want to delete the rule?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onConfirm}
        style={{
          backgroundColor: "#d32f2f",
          color: "#fff",
        }}
        variant="contained"
      >
        Delete
      </Button>
      <Button onClick={onClose} color="primary" variant="outlined">
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmationDialog;
